import { useEffect, useState } from "react";
import dashboardServices from "../../../services/hoa-dashboard-api-service";
import React from "react";
import { Container, LinearProgress } from "@mui/material";
import CustomModal from "../../../ui/Modal";

type MailLogProps = {
	isMailLogModalOpen: any;
	mailLogModalClose: any;
	selectedRowId: any;
	setSelectedRowId: any;
	mailOrEmail: any;
	responsiveHeight: number;
};

const MailLogComponent = (props: MailLogProps) => {
	const { isMailLogModalOpen, mailLogModalClose, selectedRowId, mailOrEmail, responsiveHeight } =
		props;

	const tabWidth = ["18%", "30%", "35%", "18%"];
	const [logs, setLogs] = useState([]);
	const [isLogLoading, setLogLoading] = useState(false);

	const getCreatedLogs = async () => {
		try {
			setLogLoading(true);

			const [logsResponse, appLogsResponse] = await Promise.all([
				dashboardServices.getCreatedMailLogs(selectedRowId, mailOrEmail),
				dashboardServices.getCreatedLogs(selectedRowId, 100, 1),
			]);
			const combinedLogs = [...logsResponse.data, ...appLogsResponse.data.createdlogs];
			setLogs(combinedLogs);
		} catch (error) {
			console.error("Error fetching logs:", error);
		} finally {
			setLogLoading(false);
		}
	};

	useEffect(() => {
		if (selectedRowId && isMailLogModalOpen) {
			getCreatedLogs();
		}
		return () => {
			setLogs([]);
		};
	}, [selectedRowId, isMailLogModalOpen]);

	return (
		<CustomModal
			height={"645px"}
			width={"678px"}
			isOpen={isMailLogModalOpen}
			closeModalClick={mailLogModalClose}
		>
			<Container>
				<div style={{ margin: "24px 24px 0 24px" }}>
					<span className="text-3E3E3E-18px">Change Log</span>
					<div style={{ marginTop: "24px" }}>
						{isLogLoading ? <LinearProgress style={{ height: "2px" }} /> : null}
						<table className="table-container">
							<thead style={{ margin: "0 auto" }}>
								<tr className="table-header">
									{["Entry ID", "Timestamp", "User", "Action"].map(
										(header: string, index: number) => {
											return (
												<TableHeaderComponent
													key={header}
													header={header}
													index={index}
													tabWidth={tabWidth}
												/>
											);
										}
									)}
								</tr>
							</thead>
							<tbody
								style={{
									height: `${window.innerHeight - responsiveHeight}px`,
									width: "calc( 100% + 2px)",
									overflow: "auto",
									borderBottom: "1px solid #E8E8E8",
									borderRadius: "4px",
									paddingBottom: "2px",
								}}
							>
								{logs.length <= 0 && !isLogLoading ? (
									<div className="center-text">No Available Logs!!!</div>
								) : (
									logs.map((row: any, index: number) => {
										if (row && row.objectId) {
											return (
												<TableRowComponent
													key={row.objectId}
													row={row}
													tabWidth={tabWidth}
												/>
											);
										}
									})
								)}
							</tbody>
						</table>
					</div>
				</div>
			</Container>
		</CustomModal>
	);
};

const TableRowComponent = ({ row, tabWidth }: any) => (
	<tr className="table-body">
		<td style={{ width: tabWidth[0] }} className="table-body-container">
			{row.objectId}
		</td>
		<td style={{ width: tabWidth[1] }} className="table-body-container">
			{row.createdAt}
		</td>
		<td style={{ width: tabWidth[2] }} className="table-body-container">
			{row.updatedBy || row.user}
		</td>
		<td style={{ width: tabWidth[3], paddingLeft: "20px" }} className="table-body-container">
			{row?.action || row.billItem}
		</td>
	</tr>
);

const TableHeaderComponent = ({ header, index, tabWidth }: any) => (
	<th
		key={header}
		style={{
			background: "#EFF4FC",
			width: tabWidth[index],
		}}
		className="table-header-title-container"
	>
		{header}
	</th>
);

export default MailLogComponent;
